import { ReactNode } from 'react'

import { styled } from 'styled-components'

import { onSurface } from 'core/styles'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 40px;
`

const DashboardPageTitle = ({ children }: { children: ReactNode }) => <Container>{children}</Container>

DashboardPageTitle.Title = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  line-height: 24px;
  color: ${onSurface};
  font-size: 22px;
  font-weight: 700;
`

DashboardPageTitle.Status = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-end;
`

export default DashboardPageTitle
